import { Box, Title } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import i18n from 'modules/core/lib/i18n'

import type {
  InvoiceForm,
  LegalEntity,
} from 'modules/finance/components/Invoices/Detail/Content/Form/types'
import { LegalEntitySelector } from 'modules/finance/components/LegalEntitySelector'

interface LegalEntitySectionProps {
  form: FormikProps<InvoiceForm>
  legalEntities: LegalEntity[]
  readonly: boolean
}

export const LegalEntitySection: React.FC<LegalEntitySectionProps> = ({
  form,
  legalEntities,
  readonly,
}) => {
  if (legalEntities.length === 0) {
    return null
  }

  return (
    <Box gap="s8" paddingTop="s8">
      <Title variant="400" title={i18n.t('finance.invoices.detail.fields.billed_to')} />

      <LegalEntitySelector
        legalEntities={legalEntities}
        selectedLegalEntity={form.values.legalEntity}
        readOnly={readonly}
        onSelectLegalEntity={(value) => form.setValues({ ...form.values, legalEntity: value })}
        noneOption={i18n.t('finance.invoices.detail.fields.legal_entity_place_holder')}
        error={form.errors.legalEntity}
      />
    </Box>
  )
}
